import React, {useState} from 'react';
import SurfResultParagraph from './SurfResultParagraph';
import SurfResultImage from './SurfResultImage';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../css/style.css';

const SurfResult = (props) =>{
    const [resultTabIndex,setResultTabIndex]=useState(0)

    if (props.pageData) {
        return (
            <div className="tabs_panel">
            <Tabs   className ="search-tab" 
                    selectedTabPanelClassName="search_tab-panel--selected" 
                    selectedTabClassName="search_tab--selected"
                    disabledTabClassName="search_tab--disabled"
                    selectedIndex={resultTabIndex} 
                    onSelect={resultTabIndex => setResultTabIndex(resultTabIndex)}//onSelect={( tabIndex ) => this.onSelectTab(ResulttabIndex)} 
            >
                <TabList className="search-tab-list">
                    <Tab className ="search_tab">{props.pageData.length!==0 && props.pageData[0].F20104!== undefined?props.pageData[0].F20104:20104/*آوانویسی و ترجمه*/}</Tab>
                    <Tab className ="search_tab">   {
                                                        props.selectedBookGroup === '5'
                                                        ?
                                                        props.pageData.length!==0 && props.pageData[0].F20108!== undefined?props.pageData[0].F20108:20108/*دستنویس*/
                                                        :    
                                                        props.pageData.length!==0 && props.pageData[0].F20105!== undefined?props.pageData[0].F20105:20105/*نسخه انتقادی*/
                                                    }
                                                    </Tab>
                </TabList>

                <TabPanel className ="search_tab-panel">
                    
                    <SurfResultParagraph        selectedBook={props.selectedBook}
                                                selectedChapter={props.selectedChapter}
                                                selectedBookGroup={props.selectedBookGroup}
                                                pageData={props.pageData}
                                                setLoadingShow = {props.setLoadingShow}
                                                
                    />
                </TabPanel>
                <TabPanel className ="search_tab-panel">
                    <SurfResultImage    selectedBook={props.selectedBook}
                                        selectedChapter={props.selectedChapter}
                                        pageData={props.pageData}
                                        setLoadingShow = {props.setLoadingShow}

                    />                            
                </TabPanel>
            </Tabs>
            </div>
        )
    }
    else
    {
        return (
            <div></div>
        )
    }
}

export default SurfResult;